<template>
  <div class="i-background">
    <img
      v-if="props.backgroundImage"
      class="container image-background"
      :src="props.backgroundImage"
      alt="background"
      :style="backgroundStyleWithImage"
    />
    <div
      v-else
      class="container"
      :style="backgroundStyleWithoutImage"
    ></div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue"
import { black50 } from "@/styles/colors"

const props = defineProps({
  color: {
    type: String,
    default: black50
  },
  backgroundImage: {
    type: String,
    default: undefined
  },
  imagePosition: {
    type: String,
    default: "bottom right"
  }
})

const backgroundStyleWithImage = computed(() => ({
  ["--background-color"]: props.color,
  ["--background-position"]: props.imagePosition
}))

const backgroundStyleWithoutImage = computed(() => ({
  backgroundColor: props.color
}))
</script>

<style scoped lang="scss">
.i-background {
  z-index: $z-index-background;
  position: fixed;
  width: 100vw;
  height: 100vh;

  .container {
    width: 100%;
    height: 100%;

    &.image-background {
      background-size: cover;
      background-repeat: no-repeat;
      background-position: var(--background-position);
      background-image: var(--background-image);
    }
  }
}
</style>
